import React, { FC } from 'react'

import { IconProps, Icons } from '../Icon'

import * as SC from './styled'

type DeclarationStep = {
  name: string
  icon: IconProps
  active?: boolean
  completed?: boolean
}

export type DeclarationStepperProps = {
  className?: string
  steps: DeclarationStep[]
}

const DeclarationStepper: FC<DeclarationStepperProps> = (props) => {
  const { className, steps } = props

  return (
    <SC.Container className={className}>
      {steps.map((step, index) => (
        <SC.Step key={index} $active={step.active} $completed={step.completed}>
          <SC.FakeIcon />
          <SC.StepName>{step.name}</SC.StepName>
          {step.completed ? <SC.StepIcon icon={Icons.fullCheck} /> : <SC.StepIcon {...step.icon} />}
        </SC.Step>
      ))}
    </SC.Container>
  )
}

export default DeclarationStepper
